import http from "@/shared/services/http";

export const login = (data: any) => http.post(`auth/login`, data);
export const register = (data: any) => http.post(`auth/customer-register`, data);
export const userData = () => http.get(`v1/accounts/user-data`);
export const listNotification = (params: any) => http.get(`v1/customer/notifications`,{ params });
export const readNotification = (id: any) => http.put(`v1/customer/notifications/${id}`);
export const singleNotification = (id: any) => http.get(`v1/customer/notifications/${id}`);
export const countNotification = () => http.get(`v1/customer/notifications/count`);